import {
  RequestCreateRowenaContentVariable,
  RowenaAvailableVariableGroup,
} from 'types/api/SystemTenant/RowenaAI/RowenaContentTypes';

export const ROWENA_VARIABLE_MIME = 'application/x-rowena-variable';

// TODO(api-driven): drive this list from useGetRowenaAvailableVariables once the
// @-mention popover is refactored. Until then it is a static allow-list shared
// by the suggestion popover and the editor's drop validator.
export const ROWENA_VARIABLE_NAMES = [
  'USER_FULL_NAME',
  'CURRENT_PAGE_NAME',
  'MEASUREMENT',
  'MEASUREMENT_CELL_COLOR_RULES',
  'TIME_PERIODE',
  'TOTAL_PERIOD',
];

export const mergeApiVariablesWithExisting = (
  existing: RequestCreateRowenaContentVariable[] | null | undefined,
  apiGroups: RowenaAvailableVariableGroup[] | undefined
): RequestCreateRowenaContentVariable[] => {
  const merged: RequestCreateRowenaContentVariable[] = [...(existing ?? [])];
  const seen = new Set(merged.map((variable) => variable.name));

  const walk = (groups: RowenaAvailableVariableGroup[] | undefined) => {
    (groups ?? []).forEach((group) => {
      group.variables.forEach((variable) => {
        if (!seen.has(variable.name)) {
          merged.push({ name: variable.name, variableType: variable.variableType });
          seen.add(variable.name);
        }
      });
      walk(group.groups);
    });
  };
  walk(apiGroups);

  return merged;
};
